import {
    EuiFlexGrid,
    EuiFlexGroup,
    EuiFlexItem,
    EuiPage,
    EuiPageBody,
    EuiPageContent,
    EuiSpacer,
} from "@elastic/eui";
import React, { useCallback, useContext, useEffect, useReducer, useState } from "react";

import moment from "moment";
import ProfileStatsEntity from "./ProfileStatsEntity";
import ProfileStatsHeader from "./ProfileStatsHeader";

import Api from "../../../../../lib/api";
import { EntityProfileContext } from ".";

import { currentYear, currentMonth } from "./constants";

const fetchStats = async ({ entityName, entityId, from, to }) => {
    const response = await Api.get(
        `/${entityName}/${entityId}/stats?group_by=month&from_date=${from}&to_date=${to}`
    );

    return response;
};

const initialState = {
    stats: {},
    isLoading: false,
};

const statsReducer = (state, action) => {
    switch (action.type) {
        case "START":
            return { ...state, isLoading: true };
        case "FAILURE":
            return { stats: {}, isLoading: false };
        case "SUCCESS":
            return { stats: action.stats, isLoading: false };
        default:
            return state;
    }
};

function ProfileStats() {
    const [{ isLoading, stats }, dispatch] = useReducer(statsReducer, initialState);
    const [statsMonth, setStatsMonth] = useState(currentMonth);

    const { entityName, entityId, statsFields } = useContext(EntityProfileContext);

    const handleDateChange = useCallback((name, value) => {
        setStatsMonth(value);
    }, []);

    const getStats = useCallback(async () => {
        const statsMomentDate = moment().set("month", statsMonth).set("year", currentYear).clone();
        const startOfMonth = statsMomentDate.startOf("month").locale("en").format();
        const endOfMonth = statsMomentDate.endOf("month").locale("en").format();

        dispatch({ type: "START" });

        try {
            const statsResource = await fetchStats({
                entityName,
                entityId,
                from: encodeURIComponent(startOfMonth),
                to: encodeURIComponent(endOfMonth),
            });

            const statsAttributes =
                statsResource.entities[entityName][`_${entityId}`].attributes[0];

            dispatch({ type: "SUCCESS", stats: statsAttributes });
        } catch (error) {
            dispatch({ type: "FAILURE" });
        }
    }, [entityName, entityId, statsMonth]);

    useEffect(() => {
        getStats();
    }, [getStats]);

    return (
        <EuiPage>
            <EuiPageBody>
                <EuiSpacer size="m" />
                <EuiPageContent
                    paddingSize="s"
                    hasShadow={false}
                    borderRadius="none"
                    color="transparent"
                >
                    <EuiFlexGroup
                        direction="column"
                        gutterSize="m"
                    >
                        <EuiFlexItem grow={false}>
                            <ProfileStatsHeader
                                statsMonth={statsMonth}
                                onStatsMonthChange={handleDateChange}
                                isLoading={isLoading}
                            />
                        </EuiFlexItem>

                        <EuiFlexItem grow={false}>
                            <EuiSpacer size="m" />
                        </EuiFlexItem>

                        <EuiFlexItem grow={false}>
                            <EuiFlexGrid
                                columns={4}
                                gutterSize="xl"
                            >
                                {statsFields.map((option) => (
                                    <EuiFlexItem
                                        key={option.name}
                                        style={{ padding: "0 10px" }}
                                    >
                                        <ProfileStatsEntity
                                            option={option}
                                            stats={stats}
                                        />
                                    </EuiFlexItem>
                                ))}
                            </EuiFlexGrid>
                        </EuiFlexItem>

                        <EuiFlexItem>
                            <EuiSpacer size="m" />
                        </EuiFlexItem>
                    </EuiFlexGroup>
                </EuiPageContent>
            </EuiPageBody>
        </EuiPage>
    );
}

export default ProfileStats;
